import { Routes } from '@angular/router';
import { InteriorLayoutComponent } from '@shared/layouts/interior-layout/interior-layout.component';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGuard } from '@core/guards/role.guard';

export const appRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'map',
    },
    {
        path: 'signed-out',
        loadComponent: () => import('./login/pages/signed-out/signed-out.component').then((m) => m.SignedOutComponent),
    },
    {
        path: 'map',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./map/map.routes').then((m) => m.mapRoutes),
        canActivate: [MsalGuard],
    },
    {
        path: 'floors',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./floors/floors.routes').then((m) => m.floorsRoutes),
        canActivate: [MsalGuard],
    },
    {
        path: 'layers',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./layers/layers.routes').then((m) => m.layersRoutes),
        canActivate: [MsalGuard],
    },
    {
        path: 'editor',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./editor/editor.routes').then((m) => m.editorRoutes),
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: ['Owner', 'Admin'] },
    },
    {
        path: 'report',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./report/report.routes').then((m) => m.reportRoutes),
        canActivate: [MsalGuard],
    },
    {
        path: 'analytics',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./analytics/analytics.routes').then((m) => m.analyticsRoutes),
        canActivate: [MsalGuard],
    },
    {
        path: 'intelligence',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./intelligence/intelligence.routes').then((m) => m.intelligenceRoutes),
        canActivate: [MsalGuard],
    },
    {
        path: 'settings',
        component: InteriorLayoutComponent,
        loadChildren: () => import('./settings/settings.routes').then((m) => m.settingsRoutes),
        canActivate: [MsalGuard],
    },
    // {
    //     path: '',
    //     pathMatch: 'full',
    //     redirectTo: 'floors',
    // },
    // // {
    // //     path: 'floors',
    // //     component: FloorsLayoutComponent,
    // //     children: [
    // //         {
    // //             path: '',
    // //             component: FloorsPageComponent,
    // //         },
    // //     ],
    // // },
    // {
    //     path: 'floors',
    //     component: InteriorLayoutComponent,
    //     children: [
    //         {
    //             path: '',
    //             component: FloorsPageComponent,
    //         },
    //     ],
    //     // canActivate: [MsalGuard],
    // },

    // Option 1: Lazy Loading another Routing Config
    // {
    //     path: 'flight-booking',
    //     loadChildren: () =>
    //         import('./booking/flight-booking.routes')
    //             .then(m => m.FLIGHT_BOOKING_ROUTES)
    // },

    // // Option 2: Directly Lazy Loading a Standalone Component
    // {
    //     path: 'next-flight',
    //     loadComponent: () =>
    //         import('./next-flight/next-flight.component')
    //             .then(m => m.NextFlightComponent)
    // },
    // [...]
];

// path: '',
// component: FloorsLayoutComponent,
// children: [
//     {
//         path: '',
//         component: FloorsPageComponent,
//     },
// ],
